module.exports = __webpack_public_path__ + "img/Switzerland.b4422642.png";